export enum VisitType {
    VIDEO_CALL = 'VIDEO_CALL',
    PHONE_CALL = 'PHONE_CALL',
}
